import type { AcquirerToVirtualDto } from "src/app/features/Acquirer/types/subTypes/AcquirerToVirtualDto";
import type { AcquirerToVirtualEntity } from "src/app/features/Acquirer/types/subTypes/AcquirerToVirtualEntity";

export const AcquirerToVirtualDtoToEntity = (dto: Readonly<AcquirerToVirtualDto>): AcquirerToVirtualEntity => ({ ...dto });
